import { Badge } from '@civilgrid/ui/components';
import type { Project } from '~/common/types';

interface Props {
  project: { isConfidential: Project['isConfidential'] };
}

export default function ({ project }: Props) {
  const { isConfidential } = project;

  const els = [];

  if (isConfidential) {
    els.push(
      <Badge key="confidential" color="red" className="mb-2 w-full justify-center">
        ⚠️ CONFIDENTIAL PROJECT - Do not share project details with agencies
      </Badge>,
    );
  }

  return els;
}
